const songs = [
  {
    artist: '311',
    titles: [
      'Amber'
    ]
  },
  {
    artist: '4 Non Blondes',
    titles: [
      'What\'s Up'
    ]
  },
  {
    artist: 'Alanis Morissette',
    titles: [
      'You Oughta Know'
    ]
  },
  {
    artist: 'Amy Winehouse',
    titles: [
      'Valerie'
    ]
  },
  {
    artist: 'Brooks & Dunn',
    titles: [
      'Neon Moon'
    ]
  },
  {
    artist: 'Brothers Osborne',
    titles: [
      'Weed, Whiskey & Willie'
    ]
  },
  {
    artist: 'The Chicks',
    titles: [
      'Goodbye Earl'
    ]
  },
  {
    artist: 'Chris Cornell',
    titles: [
      'Nothing Compares 2 U'
    ]
  },
  {
    artist: 'Chris Stapleton',
    titles: [
      'Tennessee Whiskey'
    ]
  },
  {
    artist: 'Christina Perri',
    titles: [
      'A Thousand Years'
    ]
  },
  {
    artist: 'Collective Soul',
    titles: [
      'Shine'
    ]
  },
  {
    artist: 'The Cranberries',
    titles: [
      'Zombie'
    ]
  },
  {
    artist: 'Creed',
    titles: [
      'Higher'
    ]
  },
  {
    artist: 'Dawes',
    titles: [
      'When My Time Comes'
    ]
  },
  {
    artist: 'Dolly Parton',
    titles: [
      'Jolene'
    ]
  },
  {
    artist: 'The Eagles',
    titles: [
      'Take It Easy'
    ]
  },
  {
    artist: 'Ed Sheeran',
    titles: [
      'Perfect'
    ]
  },
  {
    artist: 'Ella Langley',
    titles: [
      'Choosin\' Texas'
    ]
  },
  {
    artist: 'Eve 6',
    titles: [
      'Inside Out'
    ]
  },
  {
    artist: 'Fleetwood Mac',
    titles: [
      'Dreams',
      'Landslide'
    ],
  },
  {
    artist: 'The Flys',
    titles: [
      'Got You (Where I Want You)'
    ]
  },
  {
    artist: 'Foo Fighters',
    titles: [
      'Everlong',
      'My Hero'
    ]
  },
  {
    artist: 'Garth Brooks',
    titles: [
      'Friends in Low Places'
    ]
  },
  {
    artist: 'The Georgia Satellites',
    titles: [
      'Keep Your Hands to Yourself'
    ]
  },
  {
    artist: 'Goo Goo Dolls',
    titles: [
      'Iris',
      'Sympathy'
    ]
  },
  {
    artist: 'The Greatest Showman',
    titles: [
      'This Is Me'
    ]
  },
  {
    artist: 'Green Day',
    titles: [
      'Basket Case'
    ]
  },
  {
    artist: 'Guns N\' Roses',
    titles: [
      'Knockin\' on Heaven\'s Door',
      'Sweet Child O\' Mine'
    ]
  },
  {
    artist: 'Hootie & the Blowfish',
    titles: [
      'Hold My Hand',
      'I Go Blind'
    ]
  },
  {
    artist: 'Jason Mraz',
    titles: [
      'I\'m Yours'
    ]
  },
  {
    artist: 'Jimmy Eat World',
    titles: [
      'The Middle'
    ]
  },
  {
    artist: 'John Denver',
    titles: [
      'Country Roads'
    ]
  },
  {
    artist: 'Johnny Cash',
    titles: [
      'Folsom Prison Blues',
      'Jackson'
    ]
  },
  {
    artist: 'Journey',
    titles: [
      'Don\'t Stop Believin\''
    ]
  },
  {
    artist: 'Katie Tunseth',
    titles: [
      'Black Horse and the Cherry Tree'
    ]
  },
  {
    artist: 'Lady A',
    titles: [
      'Need You Now'
    ]
  },
  {
    artist: 'Lit',
    titles: [
      'My Own Worst Enemy'
    ]
  },
  {
    artist: 'Little Big Town',
    titles: [
      'Boondocks',
      'Girl Crush'
    ]
  },
  {
    artist: 'Lynyrd Skynyrd',
    titles: [
      'Sweet Home Alabama'
    ]
  },
  {
    artist: 'Matchbox Twenty',
    titles: [
      '3 A.M.'
    ]
  },
  {
    artist: 'Miley Cyrus',
    titles: [
      'Flowers',
      'Party in the U.S.A.'
    ]
  },
  {
    artist: 'Morgan Wallen',
    titles: [
      'Cover Me Up',
      'Whiskey Glasses'
    ]
  },
  {
    artist: 'Nathaniel Rateliff',
    titles: [
      'Howling at The Moon'
    ]
  },
  {
    artist: 'Neil Diamond',
    titles: [
      'Sweet Caroline'
    ]
  },
  {
    artist: 'Nitty Gritty Dirt Band',
    titles: [
      'Fishin\' in the Dark'
    ]
  },
  {
    artist: 'Old Crow Medicine Show',
    titles: [
      'Wagon Wheel'
    ]
  },
  {
    artist: 'The Outfield',
    titles: [
      'Your Love'
    ]
  },
  {
    artist: 'Radiohead',
    titles: [
      'Creep'
    ]
  },
  {
    artist: 'The Red Clay Strays',
    titles: [
      'Wondering Why'
    ]
  },
  {
    artist: 'Semisonic',
    titles: [
      'Closing Time'
    ]
  },
  {
    artist: 'Shania Twain',
    titles: [
      'Man! I Feel Like a Woman!'
    ]
  },
  {
    artist: 'Sister Hazel',
    titles: [
      'All for You'
    ]
  },
  {
    artist: 'Steelers Wheel',
    titles: [
      'Stuck in the Middle With You'
    ]
  },
  {
    artist: 'Steve Miller Band',
    titles: [
      'The Joker'
    ]
  },
  {
    artist: 'Sublime',
    titles: [
      'Santeria',
      'What I Got'
    ]
  },
  {
    artist: 'Taylor Swift',
    titles: [
      'Love Story'
    ]
  },
  {
    artist: 'Teddy Swims',
    titles: [
      'Lose Control'
    ]
  },
  {
    artist: 'Tom Petty',
    titles: [
      'American Girl'
    ]
  },
  {
    artist: 'Violent Femmes',
    titles: [
      'Blister in the Sun'
    ]
  },
  {
    artist: 'Walker Hayes',
    titles: [
      'Fancy Like'
    ]
  },
  {
    artist: 'Weezer',
    titles: [
      'Say It Ain\'t So'
    ]
  },
  {
    artist: 'Wheatus',
    titles: [
      'Teenage Dirtbag'
    ]
  },
  {
    artist: 'Zac Brown Band',
    titles: [
      'Chicken Fried'
    ]
  },
  {
    artist: 'Zach Bryan',
    titles: [
      'Something in the Orange'
    ]
  }
]

export default songs;